var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "scroll-fire-fox cluster-scroll" }, [
    _c("div", { staticClass: "cluster-hp-div" }, [
      _c("div", { staticClass: "cluster-hp-title" }, [
        _vm._v(_vm._s(_vm.$tc("Detail", 2)))
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "cluster-hp-label" }, [
        _vm._v(
          "\n      " +
            _vm._s(_vm.$t("MaxHP")) +
            ": " +
            _vm._s(_vm.countHPs) +
            "/" +
            _vm._s(_vm.maxHPs) +
            "\n    "
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "cluster-hp-div" }, [
      _c("label", { staticClass: "cluster-hp-title" }, [
        _vm._v("\n      " + _vm._s(_vm.$t("configuration")) + "\n    ")
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "automatic-pathway-creation-fields-container" },
        [
          _c("div", { staticClass: "cluster-hp-div" }, [
            _c(
              "div",
              [
                _c("v-checkbox", {
                  staticClass: "multi-selection-checkbox",
                  attrs: {
                    label: _vm.$i18n.t("BuildingsIncludedOnly"),
                    color: "accent",
                    ripple: false
                  },
                  model: {
                    value: _vm.fields.filter_bd_include,
                    callback: function($$v) {
                      _vm.$set(_vm.fields, "filter_bd_include", $$v)
                    },
                    expression: "fields.filter_bd_include"
                  }
                })
              ],
              1
            )
          ])
        ]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "cluster-hp-div" }, [
      _c("label", { staticClass: "cluster-hp-title" }, [
        _vm._v("\n      " + _vm._s(_vm.$t("AutomaticCableCreation")) + "\n    ")
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "automatic-pathway-creation-fields-container" },
        [
          _c("div", { staticClass: "cluster-hp-div" }, [
            _c(
              "label",
              { staticClass: "required", attrs: { for: "ownerCable" } },
              [
                _vm._v(
                  "\n          " + _vm._s(_vm.$tc("Owner", 1)) + "\n        "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              [
                _c("treeselect", {
                  attrs: {
                    options: _vm.ownersOptions,
                    "load-options": _vm.loadOwnerOptions,
                    normalizer: _vm.normalizerList,
                    required: "",
                    instanceId: "ownerCable"
                  },
                  model: {
                    value: _vm.fields.cable_owner,
                    callback: function($$v) {
                      _vm.$set(_vm.fields, "cable_owner", $$v)
                    },
                    expression: "fields.cable_owner"
                  }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "cluster-hp-div" }, [
            _c(
              "label",
              {
                staticClass: "required",
                attrs: { for: "materialReferenceCable" }
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.$t("MaterialReference")) +
                    "\n        "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              [
                _c("treeselect", {
                  attrs: {
                    options: _vm.materialCableOptions,
                    "load-options": _vm.loadMaterialCableOptions,
                    normalizer: _vm.normalizerMaterial,
                    required: "",
                    instanceId: "materialReferenceCable"
                  },
                  model: {
                    value: _vm.fields.cable_material_reference,
                    callback: function($$v) {
                      _vm.$set(_vm.fields, "cable_material_reference", $$v)
                    },
                    expression: "fields.cable_material_reference"
                  }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "cluster-hp-div" }, [
            _c("label", { attrs: { for: "maxCableLength" } }, [
              _vm._v(
                "\n          " + _vm._s(_vm.$t("MaxCableLength")) + "\n        "
              )
            ]),
            _vm._v(" "),
            _c("div", [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.cableDistance,
                    expression: "cableDistance"
                  }
                ],
                staticClass: "automatic-pathway-creation-input-field",
                attrs: {
                  id: "maxCableLength",
                  type: "number",
                  value: "maxCableLength",
                  min: 0
                },
                domProps: { value: _vm.cableDistance },
                on: {
                  input: [
                    function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.cableDistance = $event.target.value
                    },
                    function($event) {
                      return _vm.$emit("changeValue", {
                        prop: "maxCableLength",
                        value: _vm.cableDistance
                      })
                    }
                  ]
                }
              }),
              _vm._v(" "),
              _c("span", [_vm._v(" m")])
            ])
          ])
        ]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "cluster-hp-div" }, [
      _c("label", { staticClass: "cluster-hp-title" }, [
        _vm._v(
          "\n      " + _vm._s(_vm.$t("AutomaticPathwayCreation")) + "\n    "
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "automatic-pathway-creation-fields-container" },
        [
          _c("div", { staticClass: "cluster-hp-div" }, [
            _c(
              "div",
              [
                _c("v-checkbox", {
                  staticClass: "multi-selection-checkbox",
                  attrs: {
                    label: _vm.$i18n.t("DontUsePathwaysIgnored"),
                    color: "accent",
                    ripple: false
                  },
                  model: {
                    value: _vm.fields.filter_pathways_with_ignore,
                    callback: function($$v) {
                      _vm.$set(_vm.fields, "filter_pathways_with_ignore", $$v)
                    },
                    expression: "fields.filter_pathways_with_ignore"
                  }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "cluster-hp-div" }, [
            _c(
              "label",
              { staticClass: "required", attrs: { for: "ownerPathway" } },
              [
                _vm._v(
                  "\n          " + _vm._s(_vm.$tc("Owner", 1)) + "\n        "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              [
                _c("treeselect", {
                  attrs: {
                    options: _vm.ownersOptions,
                    "load-options": _vm.loadOwnerOptions,
                    normalizer: _vm.normalizerList,
                    required: "",
                    instanceId: "ownerPathway"
                  },
                  model: {
                    value: _vm.fields.pathway_owner,
                    callback: function($$v) {
                      _vm.$set(_vm.fields, "pathway_owner", $$v)
                    },
                    expression: "fields.pathway_owner"
                  }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "cluster-hp-div" }, [
            _c(
              "label",
              { staticClass: "required", attrs: { for: "typePathway" } },
              [
                _vm._v(
                  "\n          " + _vm._s(_vm.$t("PathwayType")) + "\n        "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              [
                _c("treeselect", {
                  attrs: {
                    options: _vm.pathwayTypeOptions,
                    "load-options": _vm.loadPathwayTypeOptions,
                    normalizer: _vm.normalizerList,
                    required: "",
                    instanceId: "typePathway"
                  },
                  model: {
                    value: _vm.fields.pathway_type,
                    callback: function($$v) {
                      _vm.$set(_vm.fields, "pathway_type", $$v)
                    },
                    expression: "fields.pathway_type"
                  }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "cluster-hp-div" }, [
            _c("label", { attrs: { for: "materialReferencePathway" } }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("MaterialReference")) +
                  "\n        "
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              [
                _c("treeselect", {
                  attrs: {
                    options: _vm.materialPathwayOptions,
                    "load-options": _vm.loadMaterialPathwayOptions,
                    normalizer: _vm.normalizerMaterial,
                    instanceId: "materialReferencePathway"
                  },
                  model: {
                    value: _vm.fields.pathway_material_reference,
                    callback: function($$v) {
                      _vm.$set(_vm.fields, "pathway_material_reference", $$v)
                    },
                    expression: "fields.pathway_material_reference"
                  }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "cluster-hp-div" }, [
            _c("label", { attrs: { for: "maxPathwayDist" } }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("MaxPathwayDistance")) +
                  "\n        "
              )
            ]),
            _vm._v(" "),
            _c("div", [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.pathwayDistance,
                    expression: "pathwayDistance"
                  }
                ],
                staticClass: "automatic-pathway-creation-input-field",
                attrs: {
                  id: "maxPathwayDist",
                  type: "number",
                  value: "maxPathwayDistance",
                  min: 0
                },
                domProps: { value: _vm.pathwayDistance },
                on: {
                  input: [
                    function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.pathwayDistance = $event.target.value
                    },
                    function($event) {
                      return _vm.$emit("changeValue", {
                        prop: "maxPathwayDistance",
                        value: _vm.pathwayDistance
                      })
                    }
                  ]
                }
              }),
              _vm._v(" "),
              _c("span", [_vm._v(" m")])
            ])
          ])
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9f2bc2c0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9f2bc2c0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Content/ObjectWindow/Cluster/ClusterFieldsCreate.vue
// module id = null
// module chunks = 